import React from "react";
import cn from "./helpers/cn";
import { TableVariantContext, } from "./TableHead";

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  component?: React.ElementType;
  hover?: boolean;
  selected?: boolean;
  children?: React.ReactNode;
}

const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>((props, ref) => {
  const {
    className,
    component: Component = "tr",
    hover = false,
    selected = false,
    children,
    ...other
  } = props;

  const variant = React.useContext(TableVariantContext);

  return (
    <Component
      ref={ref}
      className={cn(
        "align-middle outline-none",
        variant === "head" ? "" : "[&:last-child>td]:border-b-0",
        hover && !selected && "hover:bg-black/[0.04] transition-colors",
        selected && "bg-primary/10",
        className
      )}
      {...other}
    >
      {children}
    </Component>
  );
});

TableRow.displayName = "TableRow";

export default TableRow;
